import * as API from '../api';
import { getEndUserTokenKeyByHandler } from '../utils/endUser';

export const fetchEndUserData = async (seller, account) => {
    try {


        let _seller = seller;
        if (!seller?.handler) {
            const { data } = await API.getSellerByIdPublic({ sellerId: account?.parent?._id });
            if (!data || !data.handler) {
                return null; // fail silently we will not be able to fetch the end user
            }
            _seller = data;
        }

        const token = localStorage.getItem(getEndUserTokenKeyByHandler(_seller?.handler));
        if (!token) {
            localStorage.removeItem('endUserId');
            localStorage.removeItem('hrcCode');
            return null; // fail silently we will not be able to fetch the end user
        }

        const res = await API.getEndUserDataByTokenAndSellerHandler({
            token,
            sellerHandler: _seller?.handler
        });

        const subscriptions = res.data.seasonTickets.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
        const hrc = res.data.endUser.selectedHrc || subscriptions[0]?.hrc || "";

        localStorage.setItem('endUserId', res.data.endUser._id);
        localStorage.setItem('hrcCode', hrc);

        return {
            endUser: res.data.endUser,
            seller: _seller
        };
    } catch (e) {
        console.error(e);
        return null;
    }
};
